import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Badge } from "@/components/ui/badge";
function HeroContent() {
  const {
    posts,
    loading
  } = usePosts();
  if (loading) {
    return <div className="w-full bg-background py-32 md:py-48 flex flex-col items-center justify-center px-4 animate-pulse">
        <div className="h-6 w-32 bg-muted rounded-md mb-6" />
        <div className="h-16 md:h-24 w-full max-w-5xl bg-muted rounded-md mb-8" />
        <div className="h-4 w-64 bg-muted rounded-md" />
      </div>;
  }
  const post = posts[0];
  if (!post) return null;
  const formattedDate = post.date ? new Date(post.date).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).toUpperCase() : "";
  return <div className="w-full max-w-7xl mx-auto bg-background py-20 md:py-32 flex flex-col md:flex-row items-center gap-10 md:gap-16 px-4">
      {}
      <div className="w-full md:w-2/5 aspect-[4/3] md:aspect-square overflow-hidden rounded-lg bg-muted">
        {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-muted text-muted-foreground font-sans text-sm uppercase tracking-widest">
            Imagen no disponible
          </div>}
      </div>

      {}
      <div className="w-full md:w-3/5 flex flex-col items-start">
        <Badge variant="outline" className="mb-6 px-4 py-1 bg-primary/10 text-primary font-sans font-bold text-xs tracking-[0.2em] uppercase border-none rounded-md">
          DESTACADO DEL DÍA
        </Badge>
        
        <Link to={post.link || "#"} className="hover:opacity-90 transition-opacity">
          <h1 className="text-foreground font-serif text-4xl md:text-6xl font-bold tracking-tight text-left uppercase leading-[1.1]">
            {post.title}
          </h1>
        </Link>

        {post.excerpt && <p className="mt-6 text-muted-foreground font-sans text-lg md:text-xl text-left max-w-2xl leading-relaxed">
            {post.excerpt.replace(/<[^>]*>/g, '')}
          </p>}

        <div className="mt-8 flex flex-wrap items-center gap-3 text-muted-foreground font-sans text-xs font-semibold tracking-widest uppercase border-t border-border pt-6 w-full">
          <span>POR {post.author?.name || "REDACCIÓN 239"}</span>
          <span className="text-primary">•</span>
          <span>{formattedDate}</span>
        </div>
      </div>
    </div>;
}
export default function HeroTitle() {
  const wp_query_params = {
    post_type: 'post',
    per_page: 1,
    orderby: 'date',
    order: 'desc'
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="259028" id="noticia-de-portada" className="w-full flex flex-col bg-background text-foreground">
      <PostsProvider wp_query={{
      post_type: "post",
      per_page: 1,
      orderby: "date",
      order: "desc"
    }}>
        <HeroContent />
      </PostsProvider>
    </section>;
}